// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__zc1RT","arrow":"styles_arrow__FNxcI","symbol":"styles_symbol__mO+7O"};